/** @format */

import Page from "../../components/Page";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import User from "../../dao/User";
import React, { useEffect, useState } from "react";
import swal from "../../reusables/CustomSwal";
import {
  Button,
  Card,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import Iconify from "../../components/Iconify";
import SortableTableHeader from "../../reusables/table/SortableTableHeader";
// import {FaTrash} from "react-icons/fa";
// import {LoadingButton} from "@mui/lab";
// import {applySortFilter, getComparator} from "../../reusables/table/SortFilterUtils";

const TABLE_HEAD = [
  { id: "count", label: "No.", alignRight: false, sortable: false },
  { id: "waba_id", label: "WABA ID", alignRight: false, sortable: true },
  // {id: 'role', label: 'Role', alignRight: false, sortable: true},
];

export default function UserDetails() {
  const { userId } = useParams();
  const navigate = useNavigate();

  const [userDetails, setUserDetails] = useState({});
  const [isDataLoading, setIsDataLoading] = useState(true);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("waba_id");

  const [wabas, setWabas] = useState([]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const getUserDetails = async () => {
    try {
      let result = await User.getByID(userId);
      // console.log("RES", result);

      setWabas(result.wabas);
      setUserDetails(result);
      setIsDataLoading(false);
    } catch (e) {
      let errorMessage = "An error has occurred. Please try again.";
      await swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
      });
      navigate(-1);
    }
  };

  useEffect(() => {
    getUserDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page title="User Details">
      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Stack spacing={2} direction="row">
            <IconButton
              sx={{ p: 0, height: "100%", backgroundColor: "white" }}
              onClick={() => navigate(-1)}
            >
              <Iconify icon="eva:arrow-ios-back-fill" width={22} height={22} />
            </IconButton>
            <Typography variant="h4">User Details</Typography>
          </Stack>
          <Button
            variant="contained"
            component={RouterLink}
            to={`/user/${userId}/edit`}
            startIcon={<Iconify icon="akar-icons:pencil" />}
          >
            Edit
          </Button>
        </Stack>
        <Card sx={{ p: 4 }}>
          {isDataLoading ? (
            <Stack alignItems="center">
              <CircularProgress />
            </Stack>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Stack spacing={1}>
                  <Typography
                    variant="p"
                    sx={{ color: "gray", fontSize: "0.8em" }}
                  >
                    First Name
                  </Typography>
                  <Typography variant="p">
                    {userDetails.profile.first_name}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} md={6}>
                <Stack spacing={1}>
                  <Typography
                    variant="p"
                    sx={{ color: "gray", fontSize: "0.8em" }}
                  >
                    Last Name
                  </Typography>
                  <Typography variant="p">
                    {userDetails.profile.last_name}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack spacing={1}>
                  <Typography
                    variant="p"
                    sx={{ color: "gray", fontSize: "0.8em" }}
                  >
                    Job Title
                  </Typography>
                  <Typography variant="p">
                    {userDetails.profile.job_title}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack spacing={1}>
                  <Typography
                    variant="p"
                    sx={{ color: "gray", fontSize: "0.8em" }}
                  >
                    Email
                  </Typography>
                  <Typography variant="p">
                    {userDetails.profile.email}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack spacing={1}>
                  <Typography
                    variant="p"
                    sx={{ color: "gray", fontSize: "0.8em" }}
                  >
                    Phone Number
                  </Typography>
                  <Typography variant="p">
                    {userDetails.profile.phone_number}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack spacing={1}>
                  <Typography
                    variant="p"
                    sx={{ color: "gray", fontSize: "0.8em" }}
                  >
                    Role
                  </Typography>
                  <Typography variant="p">{userDetails.role}</Typography>
                </Stack>
              </Grid>

              {userDetails?.role === "MEMBER" && (
                <Grid item xs={12}>
                  <Stack spacing={1}>
                    <Typography
                      variant="p"
                      sx={{ color: "gray", fontSize: "0.8em" }}
                    >
                      Assigned Waba
                    </Typography>
                    <Typography variant="p">
                      {wabas && wabas[0] ? wabas[0].name : ""}
                    </Typography>
                  </Stack>
                </Grid>
              )}

              {userDetails?.role === "ADMIN" && (
                <Grid item xs={12}>
                  <Stack spacing={1}>
                    <Typography
                      variant="p"
                      sx={{ color: "gray", fontSize: "0.8em" }}
                    >
                      Assigned Waba
                    </Typography>
                    <TableContainer sx={{ minWidth: 800 }}>
                      <Table
                        style={{ backgroundColor: "white", color: "white" }}
                      >
                        <SortableTableHeader
                          order={order}
                          orderBy={orderBy}
                          headLabel={TABLE_HEAD}
                          onRequestSort={handleRequestSort}
                        />
                        <TableBody>
                          {wabas.map((item, key) => {
                            if (!item) {
                              // return <>boi</>
                            }
                            return (
                              <TableRow
                                hover
                                key={key}
                                tabIndex={-1}
                                role="checkbox"
                              >
                                <TableCell align="left">{key + 1}</TableCell>
                                <TableCell align="left">{`${item.name}`}</TableCell>
                                <TableCell align="left">{`${item.waba_id}`}</TableCell>
                                {/*<TableCell align="left">{item.role}</TableCell>*/}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Stack>
                </Grid>
              )}
            </Grid>
          )}
        </Card>
      </Container>
    </Page>
  );
}
